import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { ProductDetailHdPage } from "./ProductDetailHdPage";
import { SECURITY_HD_CONFIG } from "./security-detail-content";

export interface SecurityProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** Security HD — shared ProductDetailHdPage + physical-security hero assets. */
export function SecurityProductDetailHd(props: SecurityProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={SECURITY_HD_CONFIG} />;
}
